import htmlToImage from 'html-to-image';

//Downloads top images
var downloadBtn = document.getElementById('banner--download--png');
if (downloadBtn) {

    downloadBtn.onclick = function(e){
        e.preventDefault();       
                  
        htmlToImage.toPng(document.getElementById('banner'))
        .then(function (blob) {
            window.saveAs(blob, 'banner.png');
          });
        

    };
}

var downloadBtn = document.getElementById('banner--download--jpg');
if (downloadBtn) {

    downloadBtn.onclick = function(e){
        e.preventDefault();
        
        htmlToImage.toJpeg(document.getElementById('banner'), { quality: 0.95 })
            .then(function (dataUrl) {
              var link = document.createElement('a');
              link.download = 'banner.jpeg';
              link.href = dataUrl;
              link.click();
            });
        

    };
}